import React from 'react';
import { ReactComponent as DoctorAvatarIconSVG } from '../../assets/icons/mevo/ic_avatar_doctor.svg';
import IconPattern, { IconProps } from './_IconPattern';

const DoctorAvatarIcon: React.FunctionComponent<IconProps> = (props) => {
  return <IconPattern component={DoctorAvatarIconSVG} variantPlaces={[]} {...props} />;
};

export default DoctorAvatarIcon;
